(function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
"use strict";

(function () {
  function main() {
    if (!window.WPLeafletMapPlugin) {
      console.log('no plugin found!');
      return;
    }

    var lat_input = document.getElementById('cfish-latitude');
    var lng_input = document.getElementById('cfish-longitude');
    var lat_loc_input = document.getElementById('cfish-loc-latitude');
    var lng_loc_input = document.getElementById('cfish-loc-longitude');
    var zoom_loc_input = document.getElementById('cfish-loc-zoom');
    var map = window.WPLeafletMapPlugin.maps[0];
    var marker = window.WPLeafletMapPlugin.markers[0];

    function update_marker() {
      var latlng = marker.getLatLng();
      lat_input.value = latlng.lat;
      lng_input.value = latlng.lng;
    }

    function update_map() {
      var bounds = map.getBounds();
      var latlng = bounds.getCenter();
      var zoom = map.getZoom();
      lat_loc_input.value = latlng.lat;
      lng_loc_input.value = latlng.lng;
      zoom_loc_input.value = zoom; // update marker if outside of bounds

      if (marker) {
        if (!bounds.contains(marker.getLatLng())) {
          // move marker to center
          marker.setLatLng(latlng);
        }
      }
    }

    if (document.getElementById('cfish-latitude')) {
      marker.on('drag', update_marker);
    }

    map.on('move', update_map);
    update_map();

    if (document.getElementById('cfish-latitude')) {
      update_marker();
    }
  }

  var observer = new MutationObserver(function (mutations, me) {
    if (document.getElementById('cfish-latitude') || document.getElementById('cfish-loc-latitude')) {
      main();
      me.disconnect(); // stop observing

      return;
    }
  }); // start observing

  observer.observe(document, {
    childList: true,
    subtree: true
  });
})();

},{}]},{},[1]);
